import React from "react";
import CommonInput from "../../../components/forms/CommonInput";
import { handleChange } from "../../../helpers/handleFormChanges";
import Validation from "../../../helpers/Validation";
import ErrorSwal from "../../../components/Swal/errorSwal";
import PropTypes from "prop-types";

function PersonalizarCobranca({ valuesHook, salvaImagem }) {
  const { values, setValues } = valuesHook;

  const handleImagePreview = (e, data, setData) => {
    const file = e.target.files ? e.target.files[0] : "";

    if (
      file &&
      Validation.verificarTipoArquivo(["jpg", "png", "jpeg"], file.name)
    )
      return ErrorSwal({ title: "Por favor, selecione uma imagem." }).then(
        () => {
          e.target.value = "";
        }
      );

    if (
      file &&
      Validation.verificarTamanhoArquivo({ arquivo: file.size, mb: 10 })
    )
      return ErrorSwal({
        title: "O tamanho da imagem não pode ser maior que 10Mb.",
      });

    setData({
      ...data,
      [e.target.name]: e.target.files ? e.target.files[0] : "",
      imagePreview: e.target.files
        ? URL.createObjectURL(e.target.files[0])
        : "",
    });
  };

  return (
    <>
      <h5 className="card-title my-3">Personalizar cobrança</h5>
      <div className="row">
        <div className="col-md-3">
          <label htmlFor="nome_empresa" className="form-label">
            Logomarca
          </label>
          {values.logomarca || values.imagePreview ? (
            <>
              <img
                src={
                  values.imagePreview ? values.imagePreview : values.logomarca
                }
                alt="UploadImage"
                style={{
                  width: "-webkit-fill-available",
                  border: "#cecece solid 1px",
                }}
              />
            </>
          ) : null}
          <p>
            <small>Arquivos aceitos: png ou jpeg</small>
          </p>
          <div className="d-flex gap-2">
            <button
              type="button"
              onClick={() => {
                document.getElementById("logomarca").click();
              }}
              className="btn btn-info"
            >
              Alterar
            </button>
            <input
              type="file"
              id="logomarca"
              name="logomarca"
              accept="image/*"
              style={{ display: "none" }}
              onChange={(e) => handleImagePreview(e, values, setValues)}
            />
            <button
              type="button"
              onClick={salvaImagem}
              className="btn btn-success"
            >
              Salvar logo
            </button>
          </div>
        </div>
        <div className="col-md-7 mb-3">
          <CommonInput
            label="Nome da empresa"
            id="nome_empresa"
            value={values.nome_empresa}
            onChange={(e) => handleChange(e, values, setValues)}
          />
          <small className="text-orange">
            Atenção: Não é permitido uso de marcas e nomes de terceiros
          </small>
        </div>
        <div className="col-md-2">
          <CommonInput
            label="Cor principal"
            id="cor"
            value={values.cor}
            onChange={(e) => handleChange(e, values, setValues)}
            type="color"
            style={{ maxWidth: "3rem", padding: ".47rem" }}
          />
        </div>
      </div>
    </>
  );
}

PersonalizarCobranca.propTypes = {
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  salvaImagem: PropTypes.func.isRequired,
};

export default PersonalizarCobranca;
